import { btbTracePacks } from '@/features/end-of-lease/demo/mock-data';
import { TraceViewer } from '@/features/end-of-lease/demo/btb/trace-viewer';
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute(
    '/iata-binder/projects/$projectId/btb/$serialNumber/'
)({
    component: BTBDetailPage,
});

function BTBDetailPage() {
    const navigate = useNavigate();
    const params = useParams({ strict: false });
    const { projectId, serialNumber } = params as {
        projectId: string;
        serialNumber: string;
    };
    const pack = btbTracePacks[serialNumber];

    if (!pack) {
        return (
            <div className="container mx-auto py-6">
                <Card>
                    <CardContent className="py-10 text-center">
                        <p className="text-muted-foreground">
                            Component not found: {serialNumber}
                        </p>
                        <Button
                            className="mt-4"
                            onClick={() =>
                                navigate({
                                    to: '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder',
                                    params: { projectId, folderLetter: 'H' },
                                    search: { type: 'H003' },
                                })
                            }
                        >
                            Back to List
                        </Button>
                    </CardContent>
                </Card>
            </div>
        );
    }

    return (
        <div>
            {/* Header */}
            <div className="bg-white border-b">
                <div className="container mx-auto py-4">
                    <Button
                        variant="ghost"
                        onClick={() =>
                            navigate({
                                to: '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder',
                                params: { projectId, folderLetter: 'H' },
                                search: { type: 'H003' },
                            })
                        }
                    >
                        <ArrowLeft className="h-4 w-4 mr-2" />
                        Back to Component List
                    </Button>
                </div>
            </div>

            {/* Trace Viewer */}
            <TraceViewer pack={pack} />
        </div>
    );
}
